export const footerYear = () => {
    const currentYear = new Date().getFullYear();
    const footerElement = document.querySelector('.footer__copyRight');
    footerElement.innerHTML = `&copy; ${currentYear} FEELING GOOD`;
}